import { Tag as AntTag } from 'antd';
import { TagProps as AntTagProps } from 'antd/lib/tag';
import cx from 'classnames';
import { forwardRef } from 'react';

import styles from './Tag.module.less';

export interface TagProps extends AntTagProps {
  large?: boolean;
  bordered?: boolean;
  isNew?: boolean;
}

export const Tag = forwardRef<HTMLSpanElement, TagProps>(
  ({ children, large = false, bordered = false, isNew = false, className, ...otherProps }, ref) => (
    <AntTag
      ref={ref}
      className={cx(
        { [styles.large]: large, [styles.noBorder]: !bordered, [styles.new]: isNew },
        className,
      )}
      {...otherProps}
    >
      {children}
    </AntTag>
  ),
);
